export default __webpack_public_path__ + "static/bg-what-is-ml--mobile-dcc32855095bbf8fb348091c8a9ce1ef.webp";